import { useState, useEffect, useContext, useRef } from "react";
import { ChatSocketIoContext } from "src/shared-features/Wrappers";
import { useLazyGetMembersQuery, useLazyGetDialogByIdQuery } from "src/store/chat/api";
import { DialogType } from "../types";

type UpdatedDialog = {
  id: string;
  type: DialogType;
  title: string;
  avatarUrl: string;
  participantsCount: number;
}

export const useUpdatedDialog = () => {
  const updatedDialogId = useRef<null | string>(null);
  const [updatedDialog, setUpdatedDialog] = useState<UpdatedDialog | null>(null);

  const [getDialog, getDialogState] = useLazyGetDialogByIdQuery();

  const [getMembers, getMembersState] = useLazyGetMembersQuery();

  const chatSocket = useContext(ChatSocketIoContext);

  useEffect(() => {
    if (!chatSocket?.chatSocket)
      return;

    const updatedDialogHandler = ({ chat_id }: { chat_id?: string; }) => {
      if (!chat_id)
        return;

      updatedDialogId.current = chat_id;
      getDialog({ dialogId: chat_id });
      getMembers({ chatId: chat_id });
    };

    chatSocket?.chatSocket?.on("chatUpdate", updatedDialogHandler);
    return () => {
      chatSocket?.chatSocket?.off("chatUpdate", updatedDialogHandler);
    };
  }, [chatSocket?.chatSocket]);

  useEffect(() => {
    if(getDialogState.isUninitialized || getMembersState.isUninitialized)
      return;

    if (getDialogState.isLoading || getMembersState.isLoading)
      return;

    if (!getDialogState.data || !getMembersState.data)
      return;

    if (!updatedDialogId.current)
      return;

    setUpdatedDialog({
      id: updatedDialogId.current,
      type: getDialogState.data?.type,
      title: getDialogState.data?.title,
      avatarUrl: getDialogState.data?.avatar_url,
      participantsCount: getMembersState.data.members.length,
    });

  }, [getDialogState.isLoading || getMembersState.isLoading]);

  return updatedDialog;
};